
import { useUserMe } from 'shared/api/userMeQuery'
import { useAtom } from 'jotai'
// lazy image
import 'react-lazy-load-image-component'

// ----------------------------------------------------------------------

// @mui
import CssBaseline from '@mui/material/CssBaseline'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { CleanThemeProvider } from 'shared/theme/cleanThemeProvider'
import MotionLazy from 'shared/ui/animate/motion-lazy'
import ProgressBar from 'shared/ui/progress-bar'
import { SnackbarProvider } from 'shared/ui/Snackbar'
import { useScrollToTop } from 'shared/hooks/use-scroll-to-top'
import Router from 'app/routes/sections'
import { ChannelTalkProvider } from 'features/channel-talk/ChannelTalkProvider'
import { useEffect } from 'react'
import { useAuth } from 'shared/auth/hooks/useAuth'
import { tenantIdState } from 'shared/stores/tenant'
import { consumeIpNotAllowedFromLocation, useIpNotAllowed } from 'shared/auth/ipNotAllowed'
import IpNotAllowedView from 'features/auth/ui/IpNotAllowedView'
export default function App (): JSX.Element {
  useScrollToTop()
  const { isAuthenticated } = useAuth()
  const userMe = useUserMe()
  const [, setTenantIdState] = useAtom(tenantIdState)
  const ipNotAllowed = useIpNotAllowed()

  // SAML ログインの拒否は、callback からのリダイレクトのクエリ（?error=ip_not_allowed&clientIp=）で届く。
  // 読み込みの時に一度だけ見て、拒否画面の状態にする（クエリはここで取り除く）。
  useEffect(() => {
    consumeIpNotAllowedFromLocation()
  }, [])

  useEffect(() => {
    if (isAuthenticated && userMe) {
      if (userMe.tenants !== null && userMe.tenants.length > 0 && userMe.tenants[0].id !== null) {
        setTenantIdState(userMe.tenants[0].id)
      } else {
        console.error('Tenant ID is undefined or null in userMe')
      }
    }
  }, [isAuthenticated, userMe, setTenantIdState])

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ChannelTalkProvider pluginKey={process.env.CHANNEL_TALK_PLUGIN_KEY}>
        <CleanThemeProvider>
          <CssBaseline />
          <MotionLazy>
            <SnackbarProvider>
              <ProgressBar />
              {ipNotAllowed != null ? <IpNotAllowedView clientIp={ipNotAllowed.clientIp} /> : <Router />}
            </SnackbarProvider>
          </MotionLazy>
        </CleanThemeProvider>
      </ChannelTalkProvider>
    </LocalizationProvider>
  )
}
